import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66 17.232H0.300003V34.064H66V17.232Z" fill="#D80027" />
    <path d="M66 34.063H0.300003V51H66V34.063Z" fill="#FFDA44" />
    <path d="M66 0.399994H0.300003V17.232H66V0.399994Z" fill="black" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
